import { render, staticRenderFns } from "./SalesView.vue?vue&type=template&id=ef677404&scoped=true"
import script from "./SalesView.vue?vue&type=script&lang=js"
export * from "./SalesView.vue?vue&type=script&lang=js"
import style0 from "./SalesView.vue?vue&type=style&index=0&id=ef677404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef677404",
  null
  
)

export default component.exports